import { RPCRefresh } from '@/client/rpc'
import { WEBSITE_SETTINGS } from '@/client/settings'

export default async function subscribeWebPush(): Promise<PushSubscription> {
  // Register the service worker
  const registration = await navigator.serviceWorker.ready

  // Subscribe to push notifications
  // biome-ignore lint/suspicious/noTsIgnore: tsc vs tsgo difference — tsgo missing pushManager in DOM types
  // @ts-ignore: pushManager missing from tsgo's lib.dom.d.ts
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: WEBSITE_SETTINGS.vapidPublicKey,
  })

  // Save the subscription details on the server
  try {
    await RPCRefresh.saveWebPushSubscription({
      subscription: JSON.stringify(subscription),
    })
  } catch (err) {
    // If the server fails to save the subscription, unsubscribe from client
    await subscription.unsubscribe()
    throw err
  }

  return subscription
}
